var $$ = $$ || {};

$$.Delivery = class Delivery {
	constructor (root, options = {}) {
		var defaultOptions = {};

		this.root = root;
		this.options = _.assign(defaultOptions, options);

		this.activeForm = 1;
		this.formLastValues = {};
		this.lastCityValue = "";
		this.lastDeliveryId = false;

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_cacheNodes () {
		this.nodes = {
			switchTabButtons: this.root.find('.js-phisic, .js-jur'),

			radio: this.root.find('[name="PERSON_TYPE"]'),

			submitButton: this.root.find('.js-submit'),

			form: this.root.find('form'),

			pointsContainer: this.root.find('.js-points-container'),

			phisicCity: this.root.find('.js-phisic-city'),
			jurCity: this.root.find('.js-jur-city'),
			cityFields: this.root.find('.js-phisic-city, .js-jur-city').closest('.line').children('.f-input'),

			orderWeightInput: this.root.find('[name="ORDER_WEIGHT"]'),
			orderPriceInput: this.root.find('[name="ORDER_PRICE"]'),

			city: this.root.find('.f-delivery [name="ORDER_PROP_6_val"]'),

			chooseAPlaceEx: this.root.find('.f-delivery .FILD-ADDRESS')
		};

		this._cachePoints();
	}

	_cachePoints () {
		this.nodes.price = this.nodes.pointsContainer.find('.price');

		this.nodes.points = this.nodes.pointsContainer.find('.js-points');
		this.nodes.subPoints = this.nodes.pointsContainer.find('.js-sub-points');
		this.nodes.deliveryAddresses = this.nodes.pointsContainer.find('.js-address');

		this.nodes.subPoints.slideUp(1);

		this._toggleDeliveryAddress( this.nodes.deliveryAddresses.eq(0).val() );

		this.nodes.deliveryAddresses.on('click', (event) => {
			this._toggleDeliveryAddress( $(event.currentTarget).val() );
		});

		this.nodes.points.on('click', '> .item', (event) => {
			var currentPoint = $(event.currentTarget);

			if (currentPoint.hasClass('active')) {
				event.stopPropagation();
				return;
			}

			var childPoints = currentPoint.find('.js-sub-points');

			this.nodes.subPoints
				.filter('.active')
				.removeClass('active')
				.slideUp()
				.find(':checked')
				.removeAttr('checked');

			if (childPoints.length) {
				childPoints
					.addClass('active')
					.stop(true).slideDown();

				if (!childPoints.find(':checked').length) {
					childPoints.find('input').eq(0).prop('checked', true);

					var price = childPoints.find('.js-delivery-price').eq(0);

					this.nodes.price.text(price.length ? price.text() : 0);
				}
			} else {
				var price = currentPoint.find('.js-delivery-price').eq(0);

				this.nodes.price.text(price.length ? price.text() : 0);
			}
		});

		this.nodes.points.find('> .item.active').each((index, element) => {
			var price = $(element).find('.js-delivery-price').eq(0);

			this.nodes.price.text(price.length ? price.text() : 0);
		});

		this.nodes.subPoints.on('click', (event) => {
			event.stopPropagation();
		});
	}

	_bindEvents () {
		this.nodes.switchTabButtons.on('click', (event) => {
			var current = $(event.currentTarget);
			var itIsFormPhisic = ( this.activeForm === 1 && current.hasClass('js-phisic') );
			var itIsFormJur = ( this.activeForm === 2 && current.hasClass('js-jur') );
			var city;

			if ( itIsFormPhisic || itIsFormJur ) {
				return false;
			} else if ( current.hasClass('js-phisic') ) {
				this.activeForm = 1;

				city = this.nodes.phisicCity.val();
			} else if ( current.hasClass('js-jur') ) {
				this.activeForm = 2;

				city = this.nodes.jurCity.val();
			}

			this._changePersonType();

			this._updatePoints(this.activeForm, city, this.nodes.orderWeightInput.val(), this.nodes.orderPriceInput.val());
		});

		this.nodes.phisicCity.get(0).onchange = () => {
			this._updatePoints(this.activeForm, this.nodes.phisicCity.val(), this.nodes.orderWeightInput.val(), this.nodes.orderPriceInput.val());
		};

		this.nodes.jurCity.get(0).onchange = () => {
			this._updatePoints(this.activeForm, this.nodes.jurCity.val(), this.nodes.orderWeightInput.val(), this.nodes.orderPriceInput.val());
		};

		this.nodes.cityFields
			.on('focus', (event) => {
				this.lastCityValue = $(event.currentTarget).val();
			})
			.on('blur', (event) => {
				if ($(event.currentTarget).val() !== this.lastCityValue) {
					$(event.currentTarget).val('');
				}

				this.lastCityValue = "";
			})
			.on('keydown', (event) => {
				if (event.keyCode === 13) { // enter
					$('.search-popup .search-popup-row').first().trigger('click');

					return false;
				}
			});

		this.nodes.submitButton.on('click', (event) => {
			event.preventDefault();

			if ( this._checkForm() ) {
				this.nodes.form.submit();
			}
		});

		this.nodes.chooseAPlaceEx.on('focus', (event) => {
			if ( $(event.currentTarget).val() === '' ) {
				$('#SDEK_selectPVZ').trigger('click');
			}
		});
	}

	_ready () {
		this._changePersonType();

		this.nodes.radio.hide();

		this.nodes.form.find('.f-input[required]').data('required', true);
		this.nodes.form.find('.f-input').each((index, element) => {
			$(element).removeAttr('required');
		});
	}

	_changePersonType () {
		this.nodes.radio.removeAttr('checked');
		this.nodes.radio
			.eq(this.activeForm - 1)
			.attr('checked', true)
			.trigger('click');
	}

	_updatePoints (type, city, weight, price) {
		$.ajax({
			url: $$.Config.changeDelivery,
			method: 'POST',
			data: {
				type: type,
				city: city,
				weight: weight,
				price: price
			}
		}).done((response)=> {
			$('#SDEK_pvz, #SDEK_mask').remove();

			this.nodes.pointsContainer.html(response);

			try {
				if (this.nodes.pointsContainer.find('#POSTAMAT').length) {
					var tmpHTML = $('#SDEK_pvz').html();
					$('#SDEK_pvz').html('');
					$('#SDEK_pvz').attr('id', 'SDEK_notInUse');
					$('body').append("<div id='SDEK_pvz'>" + tmpHTML + "</div>");
					ymaps.ready(IPOLSDEK_pvz.init);
					IPOLSDEK_pvz.initCityPVZ();
				}
			} catch (e) {
				console.log(e)
			}

			this._cachePoints();
		}).fail((response)=> {
			$$.Noty['errorMessage'](response);
		});
	}

	_toggleDeliveryAddress ( id ) {
		this.nodes.form.find('.js-delivery-address-id').val( id );

		var activeFormClass = this._activeFormClass();
		var activeForm = this.nodes.form.find(activeFormClass + '-city').closest('.f-delivery');
		var toHide = '.delivery_hiden_' + id;
		var toHidePrev = '.delivery_hiden_' + this.lastDeliveryId;
		var notRequired = '.no_required_' + id;
		var notRequiredPrev = '.no_required_' + this.lastDeliveryId;
		var elem;
		var childrenInput;

		activeForm.find('.f-input').removeClass('error');

		if ( this.lastDeliveryId ) {
			activeForm.find(toHidePrev).each((index, element) => {
				elem = $(element);
				childrenInput = elem.find('.f-input');

				elem.show();
				childrenInput.data('required', true);
				childrenInput.val( this.formLastValues[ childrenInput.attr('id') ] );
			});

			activeForm.find('.block').show();

			activeForm.find(notRequiredPrev)
				.data('required', true)
				.closest('.line, .small')
				.children('.label')
				.addClass('required');
		}

		activeForm.find('.f-input').each((index, element) => {
			elem = $(element);

			this.formLastValues[ elem.attr('id') ] = elem.val();
		});

		activeForm.find(toHide).each((index, element) => {
			elem = $(element);
			childrenInput = elem.find('.f-input');

			elem.hide();
			childrenInput.data('required', false);

			childrenInput.val('');
		});

		activeForm.find(notRequired)
			.data('required', false)
			.closest('.line, .small')
			.children('.label')
			.removeClass('required');

		$('.js-tab' + activeFormClass).trigger('click');

		this.nodes.points.find('#TEXT_DELIVERY_' + this.lastDeliveryId).hide();
		this.nodes.points.find('#TEXT_DELIVERY_' + id).show();

		this.lastDeliveryId = id;
	}

	_activeFormClass () {
		var activeFormClass;

		if ( this.activeForm === 1 ) {
			activeFormClass = '.js-phisic';
		} else if ( this.activeForm === 2 ) {
			activeFormClass = '.js-jur';
		} else {
			activeFormClass = false;
		}

		return activeFormClass;
	}

	_checkForm () {
		var activeFormClass = this._activeFormClass();

		var activeForm = this.nodes.form.find(activeFormClass + '-city').closest('.f-delivery');
		var elem;
		var checkType;

		activeForm.find('.f-input').each((index, element) => {
			elem = $(element);

			if ( elem.data('required') ) {
				checkType = this._fieldType( elem );

				if ( this._checkField( elem.val(), checkType ) ) {
					elem.removeClass('error');
				} else {
					elem.addClass('error');
				}
			}
		});

		if ( activeForm.find('.f-input.error').length > 0 ) {
			return false;
		} else {
			return true;
		}
	}

	_checkField ( value, checkType ) {
		value = $.trim( value );

		if ( value === '' ) {
			return false;
		}

		if ( checkType === 'string' ) {
			if ( value > '' ) {
				return true;
			}
		} else if ( checkType === 'email' ) {
			if ( value.indexOf("@") > 0 ) {
				return true;
			}
		}

		return false;
	}

	_fieldType ( elem ) {
		var type = elem.attr('type');
		var requiredType = $.trim( elem.closest('.line, .small').children('.label').text() );
		var checkType = '';

		if ( type === 'text' ) {
			checkType = 'string';
		}

		if ( requiredType === 'E-Mail' ) {
			checkType = 'email';
		}

		return checkType;
	}
};
